import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllBuyers = (page, size) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.buyerProfiles,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      page,
      size,
    },
  });
};

export const fetchBuyerDetails = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.buyerProfile(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteBuyerProfile = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.buyerProfile(id),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addBuyerProfile = (data, id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;
  console.log(data?.need_professionals);
  return axiosInstance({
    url:
      id !== null
        ? config.routes.buyerProfile(id)
        : config.routes.buyerProfileCreate,
    method: id !== null ? "put" : "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      address: data?.address,
      city: data?.city,
      contactemail: data?.contactEmail,
      contactname: data?.contactName,
      country: data?.country,
      currency: {
        id: parseInt(data?.currency),
      },
      domain: data?.domain,
      email: data?.email,
      fax: data?.fax,
      industries: data?.industriesOpt.map((item) => item.value),
      interestedlocations: data?.interestedLocationsOpt.map(
        (item) => item.value
      ),
      investmentrange: parseInt(data?.investmentRange),
      name: data?.name,
      occupation: data?.occupation,
      phone: data?.phone,
      phone2: data?.phone2,
      postalcode: data?.postalCode,
      region: data?.region,
      startservice: data?.startService,
      website: data?.website,
      buyer_type: data?.buyer_type,
      partners: data?.partners,
      need_professionals: data?.need_professionals == "true" ? true : false,
      professional_required: data?.professional_required,
    },
  });
};
